export default __webpack_public_path__ + "static/media/spid-ico-circle-bb.2625ab5b.png";